import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, Button } from '@material-ui/core';
import { Done, Close, SwapHoriz, Replay } from '@material-ui/icons';
import { toast } from 'react-toastify';
import api from '../../services/api';
import { executeCommercialCommand } from '../../services/commercialCommands';
import { getActiveCommercialCards, commercialCardId, commercialErrorMessage, getManagedCommercialCards } from '../../utils/commercialContext';
import RegisterLossModal from '../RegisterLossModal';
import TicketQuickActions from '../TicketListItemCustom/TicketQuickActions';

export default function CommercialQuickActions({ ticket, onAction, onTransfer, classes = {} }) {
  const [busy, setBusy] = useState(false);
  const summary = ticket.commercialActions;
  const summaryKnown = Number.isSafeInteger(summary?.eligibleDealCount) && Number.isSafeInteger(summary?.unresolvedDealCount);
  const hasManagedDeal = summaryKnown && summary.eligibleDealCount > 0;
  const cannotFinalize = !summaryKnown || summary.unresolvedDealCount > 0;
  const finishTitle = !summaryKnown ? 'Carregando ações do atendimento' : cannotFinalize ? 'Existe um negócio aberto. Conclua-o pelo atendimento ou Kanban antes de finalizar.' : 'Finalizar conversa';
  const [choice, setChoice] = useState(null);
  const [lossTarget, setLossTarget] = useState(null);
  const close = async (card, outcome, extra = {}) => {
    setBusy(true);
    try { await executeCommercialCommand('close_deal', card, ticket.id, { outcome, ...extra }); toast.success('Negócio atualizado.'); }
    catch (error) { toast.error(commercialErrorMessage(error)); throw error; }
    finally { setBusy(false); }
  };
  const choose = async (card, outcome) => {
    setChoice(null);
    if (outcome === 'reopen') {
      setBusy(true);
      try { await executeCommercialCommand('reopen_card', { ...card }, ticket.id, {}); toast.success('Negócio reaberto com histórico preservado.'); }
      catch (error) { toast.error(commercialErrorMessage(error)); throw error; }
      finally { setBusy(false); }
    } else if (outcome === 'lost') setLossTarget({ ...card });
    else await close(card, outcome);
  };
  const begin = async outcome => {
    setBusy(true);
    try {
      const { data } = await api.get(`/tickets/${ticket.id}/commercial-context`);
      const active = getActiveCommercialCards(data.cards);
      if (outcome === 'finish') {
        if (active.length) toast.info('Existe um negócio aberto. Revise o atendimento antes de finalizar.');
        else onAction('close', ticket.id);
        return;
      }
      const cards = outcome === 'reopen' ? (data.cards || []).filter(card => card.dealId && (card.deal?.state ? card.deal.state !== 'open' : Boolean(card.archivedAt))) : getManagedCommercialCards(data.cards);
      if (!cards.length) {
        if (outcome === 'reopen') onAction('reopen', ticket.id);
        else toast.info('Este atendimento não tem negócio ativo com gestão habilitada. Atualize o atendimento.');
      }
      else if (cards.length === 1) await choose(cards[0], outcome);
      else setChoice({ cards, outcome });
    } catch (error) { toast.error(commercialErrorMessage(error)); }
    finally { setBusy(false); }
  };
  const actions = ticket.status === 'closed'
    ? [{ key: 'reopen', label: 'Reabrir conversa ou negócio', icon: <Replay className={classes.icon} />, disabled: busy, onClick: () => begin('reopen') }]
    : [
      ...(ticket.status === 'pending'
        ? [{ key: 'accept', label: 'Aceitar', icon: <Done className={classes.icon} />, buttonClass: 'acceptBtn', disabled: busy, onClick: () => onAction('accept', ticket.id) }]
        : [
          ...(hasManagedDeal ? [{ key: 'won', label: 'Ganho', ariaLabel: 'Ganho de um negócio', icon: <Done className={classes.icon} />, disabled: busy, onClick: () => begin('won') }] : []),
          { key: 'transfer', label: 'Transferir', title: 'Transferir Ticket', ariaLabel: 'Transferir conversa', icon: <SwapHoriz className={classes.icon} />, buttonClass: 'transferBtn', disabled: busy, onClick: onTransfer },
        ]),
      ...(hasManagedDeal
        ? [{ key: 'lost', label: 'Perda', ariaLabel: 'Perda de um negócio', icon: <Close className={classes.icon} />, disabled: busy, onClick: () => begin('lost') }]
        : [{ key: 'finish', label: 'Finalizar', title: finishTitle, ariaLabel: 'Finalizar conversa', icon: <Close className={classes.icon} />, disabled: busy || cannotFinalize, onClick: () => begin('finish') }]),
    ];
  return <span onClick={event => event.stopPropagation()}>
    <TicketQuickActions actions={actions} classes={classes} />
    <Dialog open={Boolean(choice)} onClose={() => setChoice(null)} fullWidth maxWidth="xs"><DialogTitle>Selecionar negócio</DialogTitle><DialogContent>
      {choice?.cards.map(card => <Button fullWidth key={card.id} onClick={() => choose(card, choice.outcome).catch(() => {})}>{card.title} · #{card.dealId}</Button>)}
    </DialogContent></Dialog>
    <RegisterLossModal open={Boolean(lossTarget)} onClose={() => setLossTarget(null)} cardId={commercialCardId(lossTarget)} boardId={lossTarget?.kanbanBoardId} boards={lossTarget ? [{ id: lossTarget.kanbanBoardId, name: lossTarget.kanbanBoard?.name || `Quadro ${lossTarget.kanbanBoardId}`, enableOutcomeTracking: true }] : []} onConfirm={async ({ lossReasonId }) => { await close(lossTarget, 'lost', { lossReasonId }); setLossTarget(null); }} />
  </span>;
}
